import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { btnStyle, mtsLoginLogo } from '../config/app.config';
import { routes } from '../config/routes.config';
import { HttpService, isResultValid, translate } from '../main/http-service';
import { ModalHandler } from '../main/modal/modal.handler';
import { ButtonType } from '../main/modal/button.handler';
import { InitButton } from '../main/modal/modal.button';
import { translateModal } from '../main/modal/modal.translate';

@Component({
   selector: 'app-reset-password',
   templateUrl: './reset-password.component.html',
   styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
   btn = btnStyle;

   service: HttpService;

   passwordMatchError = false;

   passwordChanged = false;

   showEmailSent = false;

   mtsLogo = mtsLoginLogo;

   token: string;

   tokenExpiredHandler: ModalHandler = new ModalHandler();

   resetPasswordForm = new FormGroup(
      {
         pw1: new FormControl({ value: '', disabled: false }, [
            Validators.required,
            Validators.minLength(12),
         ]),
         pw2: new FormControl({ value: '', disabled: false }, [
            Validators.required,
            Validators.minLength(12),
         ]),
      },
      [
         (control: FormGroup): any => {
            const pw1 = control.get('pw1');
            const pw2 = control.get('pw2');
            if (pw1.touched && pw2.touched && pw1.value !== pw2.value) {
               return { newPasswordsDoNotMatch: true };
            }
            if ((pw1.errors && pw1.errors.minlength) || (pw2.errors && pw2.errors.minlength)) {
               return { minlength: true };
            }
            if ((pw1.errors && pw1.errors.pattern) || (pw2.errors && pw2.errors.pattern)) {
               return { pattern: true };
            }
            return null;
         },
      ],
   );

   get pw1(): AbstractControl {
      return this.resetPasswordForm.get('pw1');
   }

   get pw2(): AbstractControl {
      return this.resetPasswordForm.get('pw2');
   }

   constructor(private route: ActivatedRoute, http: HttpClient, private router: Router) {
      this.service = new HttpService(http, routes.resetPassword, this.router, this.route);
      this.tokenExpiredHandler.title =
         'Your password reset link has expired. Please request a new one.';
      this.tokenExpiredHandler.ignoreBackdropClick = true;
      this.tokenExpiredHandler.closeButton = false;
      [this.tokenExpiredHandler.buttons] = InitButton(
         { type: ButtonType.OkCancel, prefix: 'confirm' },
         1,
      );
      this.tokenExpiredHandler.change.next(translateModal(this.tokenExpiredHandler, translate));
   }

   ngOnInit(): void {
      this.token = this.route.snapshot.queryParamMap.get('id');
      if (!this.token) {
         this.router.navigate(['/login']);
         return;
      }
      this.service.get<any>(
         {
            token: this.token,
         },
         (res) => {
            if (!isResultValid(res)) {
               this.tokenExpiredHandler.event.next();
               this.router.navigate(['/login']);
            }
         },
      );
      
   }

   initValue(): void {

      this.pw1.reset();
      this.pw2.reset();
   }

   async submitForm(): Promise<void> {
      if (this.resetPasswordForm.get('pw1').value === this.resetPasswordForm.get('pw2').value) {
         this.passwordMatchError = false;
         this.service.post<any>(
            {
               token: this.token,
               password: this.resetPasswordForm.get('pw1').value,
            },
            (res) => {
               if (isResultValid(res)) {
                  this.passwordChanged = true;
               }
               this.resetPasswordForm.reset();
            },
         );
      } else {
         this.passwordMatchError = true;
      }
   }
}
